<template>
  <div class="container">
    <header class=" mb-4">
        <h1 class="mb-4 border-bottom pb-2">Activity logs</h1> <br>


      
      </header>
    <div class="device-list">
      <h2>Uploaded Playlists</h2>
  
      <table v-if="displayedPlaylists.length">
        <thead>
          <tr>
            <th>Device ID</th>
            <th>Playlist Name</th>
          
            <th>Time Added</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in displayedPlaylists" :key="index">
            <td>{{ item.deviceId }}</td>
            <td>{{ item.name }}</td>
          
            <td>{{ formatTime(item.addedAt) }}</td>
          </tr>
        </tbody>
      </table>
  
      <p v-else>No playlists found.</p>
  
      <button 
        v-if="canLoadMore" 
        @click="loadMore" 
        class="load-more-button"
      >
        Load More
      </button>
    </div>
    <hr style="margin: 50px 0; border: 1px solid #333" />
    <div class="device-list">
<h2>Deleted Playlists</h2>

<table v-if="deletedPlaylists.length">
  <thead>
    <tr>
      <th>Device ID</th>
      <th>Playlist Name</th>
      <th>Time Deleted</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index) in deletedPlaylists" :key="'deleted-' + index">
      <td>{{ item.deviceId }}</td>
      <td>{{ item.name }}</td>
      
      <td>{{ formatTime(item.deletedAt) }}</td>
    </tr>
  </tbody>
</table>

<p v-else>No deleted playlists found.</p>
</div>
  </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        playlists: [],
        deletedPlaylists: [], // ⬅️ Dodato
        displayedPlaylists: [],
        itemsPerPage: 100,
        currentPage: 1,
        abortController: null, // ⬅ OVO
      };
    },
    async mounted() {
  const adminToken = localStorage.getItem("adminToken");
  this.abortController = new AbortController();

  try {
    const response = await axios.get(
      "https://app.streamboxtv.live/api3002/api/operator-devices-full",
      {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
        signal: this.abortController.signal // ⬅ OVO
      }
    );

    this.playlists = response.data.playlists || [];
this.deletedPlaylists = response.data.deleted || []; // ⬅️ Dodato
this.displayedPlaylists = this.playlists.slice(0, this.itemsPerPage);

  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("✅ Device list axios aborted.");
    } else {
      console.error("Failed to load playlists:", error);
    }
  }
},
beforeUnmount() {
  if (this.abortController) {
    this.abortController.abort();
  }
}
,
    computed: {
      canLoadMore() {
        return this.displayedPlaylists.length < this.playlists.length;
      },
    },
    methods: {
      formatTime(isoDate) {
        return new Date(isoDate).toLocaleString();
      },
      loadMore() {
        this.currentPage++;
        const nextItems = this.playlists.slice(0, this.currentPage * this.itemsPerPage);
        this.displayedPlaylists = nextItems;
      },
    },
  };
  </script>
  
  <style scoped>
  .device-list {
    padding: 20px;
    color: white;
  }
  
  h2 {
    color: #00bfff;
    margin-bottom: 15px;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    background-color: #1c1c1c;
  }
  
  th,
  td {
    border: 1px solid #444;
    padding: 10px;
    text-align: left;
  }
  
  th {
    background-color: #2a2a2a;
  }
  

  
  .load-more-button {
    margin-top: 20px;
    padding: 10px 20px;
    background-color: #00bfff;
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 5px;
  }
  
  .load-more-button:hover {
    background-color: #00a2e0;
  }
 
  header{
    color:white;
  }
  .mb-4 {
  margin-top: 20px;
}
h6{
    color:silver;
}
tr:nth-child(even){
    background-color:#303030
}
  </style>